// extracted by mini-css-extract-plugin
export default {"organismWrapper":"LandscapeIndicatorTargetTemplate_organismWrapper__OjZhP"};